import React from 'react';

import personal_banking_hand from '../../../assets/images/personal_banking_hand.png'
import contact_us_img from '../../../assets/images/contact_us_img.jpg'

import charm_tick from '../../../assets/images/charm_tick.svg'

import cl from './Personal.module.css'
import Button from '../../../components/ui/BTN/Button';
import ContactForm from '../../../components/ContactForm/ContactForm';
import { NavLink } from 'react-router-dom';

const Personal = () => {
    return (
        <div className='personal_page'>
            <div className={cl.personal_banking_container}>
                <div className={cl.personal_left_side}>
                    <h3 className={cl.personal_banking_title}>
                        Banking That Works Around You
                    </h3>
                    <p className={cl.personal_banking_descr}>
                        Manage your finances effortlessly with our smart digital platform. Open SGD and multi-currency accounts in minutes, send instant transfers, and pay bills anytime, anywhere.
                    </p>
                    <NavLink to='/sign-up'>
                    <Button />
                    </NavLink>
                </div>
                <div className={cl.personal_right_side}>
                    <img src={personal_banking_hand} alt="#personal_banking_img" />
                </div>
            </div>
            <div className={cl.personal_feautures_container}>
                <div className={cl.left_side_personal_feautures_container}>
                    <h2 className={cl.personal_feautures_title}>
                        Features
                    </h2>
                </div>
                <div className={cl.right_side_personal_feautures}>
                    <div className={cl.personal_feautures_item}>
                        <img src={charm_tick} alt="#charm_tick" />
                        <span className={cl.persolan_feautures_text}>
                            Multi-currency accounts: Hold and transact in SGD, USD, EUR, and more.
                        </span>
                    </div>
                    <div className={cl.personal_feautures_item}>
                        <img src={charm_tick} alt="#charm_tick" />
                        <span className={cl.persolan_feautures_text}>
                            Real-time notifications: Stay informed with instant alerts on your spending.
                        </span>
                    </div>
                    <div className={cl.personal_feautures_item}>
                        <img src={charm_tick} alt="#charm_tick" />
                        <span className={cl.persolan_feautures_text}>
                           Secure mobile access: Bank on the go with biometric login and two-factor authentication.
                        </span>
                    </div>
                    <div className={cl.personal_feautures_item}>
                        <img src={charm_tick} alt="#charm_tick" />
                        <span className={cl.persolan_feautures_text}>
                            Easy bill payments: Set up and schedule recurring payments seamlessly.
                        </span>
                    </div>
                </div>
            </div>
            <ContactForm />
            
        </div>
    );
};

export default Personal;